import { render, staticRenderFns } from "./ReservesList.vue?vue&type=template&id=8afa733a&scoped=true&"
import script from "./ReservesList.vue?vue&type=script&lang=js&"
export * from "./ReservesList.vue?vue&type=script&lang=js&"
import style0 from "./ReservesList.vue?vue&type=style&index=0&id=8afa733a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afa733a",
  null
  
)

export default component.exports